var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDash6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40 42v16.994c0 .75-.78 1.23-1.45.9l-6.1-3.06c-.14-.07-.29-.1-.45-.1s-.31.03-.45.1l-6.1 3.06c-.67.33-1.45-.15-1.45-.9v-16.994z",
    fill: "#00a0c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40 42v16.994c0 .75-.78 1.23-1.45.9l-6.1-3.06c-.14-.07-.29-.1-.45-.1v-14.734z",
    fill: "#c80a50"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40 42v4.33c-2.45 1.07-5.15 1.67-8 1.67v-6z",
    fill: "#a00028"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32 42v6c-2.85 0-5.55-.6-8-1.67v-4.33z",
    fill: "#0082aa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26,
    fill: "#fab400",
    r: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m52 26c0 11.05-8.95 20-20 20s-20-8.95-20-20c0-.32.01-.65.03-.97.53 10.57 9.27 18.97 19.97 18.97s19.44-8.4 19.97-18.97c.02.32.03.65.03.97z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m59 8h-3v-3c0-.552-.448-1-1-1h-2c-.552 0-1 .448-1 1v3h-3c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h3v3c0 .552.448 1 1 1h2c.552 0 1-.448 1-1v-3h3c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1z",
    fill: "#fab400"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15 44h-3v-3c0-.552-.448-1-1-1h-2c-.552 0-1 .448-1 1v3h-3c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h3v3c0 .552.448 1 1 1h2c.552 0 1-.448 1-1v-3h3c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1z",
    fill: "#fab400"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26,
    fill: "#f0f0f0",
    r: 14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32.889 17.993 1.977 4.005c.144.292.423.495.746.542l4.42.642c.813.118 1.137 1.117.549 1.69l-3.199 3.118c-.234.228-.34.556-.285.877l.755 4.402c.139.81-.711 1.427-1.438 1.045l-3.954-2.079c-.289-.152-.634-.152-.922 0l-3.954 2.079c-.727.382-1.577-.235-1.438-1.045l.755-4.402c.055-.321-.051-.65-.285-.877l-3.199-3.118c-.588-.573-.264-1.572.549-1.69l4.42-.642c.323-.047.602-.25.746-.542l1.977-4.005c.366-.736 1.416-.736 1.78 0z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.62 27.99-3.2-3.12c-.43-.42-.37-1.07.02-1.43l3.18 3.11c.23.23.34.56.28.88l-.13.75c-.04-.07-.09-.13-.15-.19z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37.85 33.27c.14.81-.71 1.43-1.44 1.05l-3.95-2.08c-.29-.15-.63-.15-.92 0l-3.95 2.08c-.73.38-1.58-.24-1.44-1.05l.13-.76c.25.42.81.63 1.31.36l3.95-2.07c.29-.16.63-.16.92 0l3.95 2.07c.5.27 1.06.06 1.31-.36z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.58 24.87-3.2 3.12c-.06.06-.11.12-.15.19l-.13-.75c-.06-.32.05-.65.28-.88l3.18-3.11c.39.36.45 1.01.02 1.43z",
    fill: "#dc9600"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash6);
export default __webpack_public_path__ + "static/media/dash6.6982cd0ff7a0a860ace8e11599d12a10.svg";
export { ForwardRef as ReactComponent };